/**
 * The session header stores the provider contact as a single free-text field, while the provider
 * notification flow addresses one chip per recipient — so an admin who needs two contacts types them
 * both into that one field. Split on the separators they realistically use, in one place, because
 * both the « Prestataire » gate and the pre-filled recipient list have to agree on the answer.
 */
export function splitTrainingPartnerContacts(trainingPartnerEmail?: string | null): string[] {
  if (!trainingPartnerEmail) return [];
  return trainingPartnerEmail
    .split(/[,;]/)
    .map((email) => email.trim())
    .filter(Boolean);
}
